<template>
  <div>
    <AdminNav></AdminNav>
    <div class="h-screen flex overflow-hidden bg-gray-100">
      <div class="md:flex md:flex-shrink-0">
        <div class="flex flex-col w-36 sm:w-56 md:w-64 bg-gray-800">
          <div class="h-0 flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
            <nav class="mt-5 flex-1 px-2 bg-gray-800">
              <router-link :to="{ name: 'admin' }" >
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="hat-cowboy"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Outfitters
                </div>
              </router-link>
              <router-link :to="{ name: 'admin-users' }" v-if = "userCan('admin-user')">
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="user"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Users
                </div>
              </router-link>
              <router-link :to="{ name: 'admin-orders' }" v-if = "userCan('admin-orders')">
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="dollar-sign"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Orders
                </div>
              </router-link>
              <router-link :to="{ name: 'admin-albums' }" v-if = "userCan('admin-albums')">
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="object-group"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Albums
                </div>
              </router-link>
              <router-link :to="{ name: 'admin-rivers' }" v-if = "userCan('admin-rivers')">
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="water"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Rivers
                </div>
              </router-link>
              <router-link :to="{ name: 'admin-river-sections' }" v-if = "userCan('admin-rivers')">
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="code-branch"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  River Sections
                </div>
              </router-link>
              <router-link :to="{ name: 'photographer' }" >
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="layer-group"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Uploader
                </div>
              </router-link>

              <div
                  v-if = "userCan('admin-reports')"
                @click="showReports = !showReports"
                class="mt-1 nav-link hover:text-white hover:bg-gray-700"
              >
                <font-awesome-icon
                  icon="paperclip"
                  size="2x"
                  class="fa-fw nav-icon"
                ></font-awesome-icon>
                Reports
                <font-awesome-icon
                  v-show="!showReports"
                  icon="chevron-right"
                  class="fa-fw ml-8"
                ></font-awesome-icon>
                <font-awesome-icon
                  v-show="showReports"
                  icon="chevron-down"
                  class="fa-fw ml-8"
                ></font-awesome-icon>
              </div>

              <div v-show="showReports" class="ml-8">
                <router-link :to="{ name: 'admin-report-photographer' }">
                  <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                    Photographer Report
                  </div>
                </router-link>
                <router-link :to="{ name: 'admin-report-comprehensive' }">
                  <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                    Comprehensive Report
                  </div>
                </router-link>
              </div>
            </nav>
          </div>
          <div class="flex-shrink-0 flex bg-gray-700 p-4">
            <a href="#" class="flex-shrink-0 group block focus:outline-none">
              <div class="flex items-center"></div>
            </a>
          </div>
        </div>
      </div>
      <div class="flex flex-col w-0 flex-1 overflow-hidden">
        <main
          class="flex-1 relative z-0 overflow-y-auto pt-2 pb-6 focus:outline-none md:py-6"
          tabindex="0"
        >
          <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mt-5">
            <router-view></router-view>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import AdminNav from "../components/ui/nav/AdminNav";
import store from "../store";
import userFunctions from "../mixins/userFunctions";
export default {
  name: "Admin",
  components: {
    AdminNav,
  },
  data() {
    return {
      showReports: false,
    };
  },
    mixins: [userFunctions],
  watch: {
    role: function () {
      // if (newRole !== "admin") {
      //   this.$router.push("/");
      // }
    },
  },
  computed: {
    role: function () {
      return store.getters["auth/getUser"].role;
    },
  },
  mounted() {},
};
</script>

<style scoped>
.nav-link {
  @apply cursor-pointer flex text-gray-300 items-center px-2 py-2 text-sm leading-5 font-medium rounded-md  transition ease-in-out duration-150;
}
.nav-icon {
  @apply mr-3 h-6 w-6 text-gray-300 transition ease-in-out duration-150;
}
.router-link-active .nav-link {
  @apply text-white bg-gray-900;
}
</style>
